import { apiGet, apiPut, apiPost, systemRequestConfig } from '@api/api.utils'
import { IResponseCommon } from "@api/common.types"

import { 
    IResponsePrimaryList, 
    IResponseCardSignature,
} from "./api.types"

import { 
    FilterParametersType,
    SignatureCardUpdateType, 
} from "./state.types"


/** Маршрут на сервер */
const route = '/signature'


/** Список, Договора на подпись - Физические лица */
export const getPrimaryList = (pageNumber: number, search?: string, filter?: FilterParametersType, isSystemRequest: boolean = false, signal?: AbortSignal): Promise<IResponsePrimaryList> => {
    const config = {params: {pageNumber, search, filter}, signal}
    return apiGet<IResponsePrimaryList>(`${route}/getPrimaryList`, isSystemRequest ? systemRequestConfig(config) : config)
}

/** Получение данных по анкете договора */
export const getSignatureCard = (contractID: number, signal?: AbortSignal): Promise<IResponseCardSignature> => 
    apiGet<IResponseCardSignature>(`${route}/getSignatureCard`, {params: {contractID}, signal})

/** Сохранение данных по анкете договора */
export const putSignatureCard = (contractID: number, data: SignatureCardUpdateType): Promise<IResponseCommon> => 
    apiPut<IResponseCommon>(`${route}/putSignatureCard`, {params: {contractID}}, {formData: data})

/** Отправка информации в Telegram канал (ИКТ - Договора на подпись) */
export const postTgSignature = (contractID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/postTgSignature`, {params: {contractID}})
